export default __webpack_public_path__ + "static/media/quiz2.1f1fa57f.png";